import * as types from '../constants/StoriesActionTypes'
import produce from 'immer'
import _ from 'lodash';
var validate = require("validate.js");
import * as moment from 'moment';

const initialState = {
    stories: null,
    ids: null,
    next: null,
    selected: null
};

const request_story = (state, storyId) => produce(state, draft => {
    draft.selected = {
        id: storyId,
        loading: true,
        dirty: false
    }
});

const receive_story = (state, storyId, data) => produce(state, draft => {
        draft.selected = {
            id: storyId,
            loading: false,
            dirty: false,
            deleted: false,
            settings_dirty: false,
            settings_saving: false,
            settings: {
                publish_on_date: moment().format('YYYY-MM-DD'),
                publish_on_time: '00:00',
                publish_until_date: moment().add('days', 7).format('YYYY-MM-DD'),
                publish_until_time: '23:59'
            },
            validation: {},
            show_publication_confirmation: false,
            isValid: false,
            version: Date.now(),
            version_saved: null,
            content: [],
            ...data
        }
});

const update_settings = (state, key, value) => produce(state, draft => {
    draft.selected.settings_dirty = true;
    draft.selected.settings[key] = value;
    draft.selected.version = Date.now();
});

const request_saving = (state, storyId) => produce(state, draft => {
    draft.selected.settings_dirty = false;
    draft.selected.settings_saving = true;
});

const receive_saving = (state, storyId, version, success) => produce(state, draft => {
    if(success){
        draft.selected.version_saved = version;
        draft.selected.settings_dirty = false;
        draft.selected.settings_saving = false;
    }
});

const update_content = (state, key, value) => produce(state, draft => {
    draft.selected.content[key] = value;
    draft.selected.content[key].dirty = true;
    draft.selected.content[key].version = Date.now();
});

const request_content_saving = (state, idx, version) => produce(state, draft => {
    draft.selected.content[idx].dirty = false;
    draft.selected.content[idx].saving = true;
});

const receive_content_saving = (state, idx, version, success) => produce(state, draft => {
    if(success){
        draft.selected.content[idx].version_saved = version;
        draft.selected.content[idx].saving = false;
    }
});

const request_stories = (state, stories) => produce(state, draft => {
    draft.loading = true;
});

const receive_stories = (state, stories, next) => produce(state, draft => {
    draft.loading = false;

    if(draft.stories === null)
        draft.stories = {};
    
    if(typeof stories !== 'undefined')
        for(let id in stories){
            draft.stories[id] = stories[id];
        }

    draft.ids = Object.keys(draft.stories);
    draft.ids.sort((a, b) => (draft.stories[b].draft.modified - draft.stories[a].draft.modified))

    if(next === null)
        draft.next = null;
    else if(draft.next === null || next.draft.modified < draft.next)
        draft.next = next.draft.modified;
});

const request_publishing = (state) => produce(state, draft => {
    draft.selected.loading = true;
});

const receive_publishing = (state, id, version, success) => produce(state, draft => {
    draft.selected.loading = false;
    draft.selected.published = true;
    draft.selected.show_publication_confirmation = true;
});

const request_deleting = (state) => produce(state, draft => {
    draft.selected.loading = true;
});

const receive_deleting = (state, id, version, success) => produce(state, draft => {
    draft.selected.loading = false;
    draft.selected.deleted = true;
});

const request_trigger_push = (state) => produce(state, draft => {
    draft.selected.notification_trigger_loading = true;
});

const receive_trigger_push = (state, id, version, success, triggeredOn) => produce(state, draft => {
    draft.selected.notification_trigger_loading = false;
    draft.selected.notification_trigger = {
        on: triggeredOn
    }
});

const create_draft = (state, id, draftId) => produce(state, draft => {
    draft.selected.loading = false;
    draft.selected.published = null;
    draft.selected.version_saved = null;
    draft.selected.draft_id = draftId;
    draft.selected.content = draft.selected.content.map((content) => ({
            ...content,
            version_saved: null
        }))
    
});

validate.validators.arrayContainsBooleanTrue = function(value, options, key, attributes) {
    if(typeof value !== 'object')return options.message;
    if(typeof Object.values(value).find((v) => v === true) === 'undefined')return options.message;

    return null;
};

validate.validators.containsTextContent = function(value, options, key, attributes) {
    if(typeof value !== 'object')return options.message;
    if(typeof Object.values(value).find((v) => (typeof v.is_deleted === 'undefined' || v.is_deleted === null || v.is_deleted === false) && v.type === 'markdown' && typeof v.payload !== 'undefined' && v.payload.length > 0) === 'undefined')return options.message;

    return null;
};

const constraints = {
  'settings.category': {
    presence: {
        allowEmpty: false,
        message: 'Es wurde keine Kategorie angegeben.'
    }
  },
  'settings.teaser_text': {
    presence: {
        allowEmpty: false,
      message: "^Es wurde kein Teasertext angegeben."
    }
  },
  'settings.notification_text': {
    presence: {
    allowEmpty: false,
      message: "^Es wurde kein Text für die Push-Benachrichtungen angegeben."
    }
  },
  'settings.publish_on_date': {
    presence: {
        allowEmpty: false,
        message: "^Es wurde kein Veröffentlichungsdatum angegeben."
    }
  },
  'settings.publish_on_time': {
    presence: {
        allowEmpty: false,
        message: "^Es wurde keine Veröffentlichungszeit angegeben."
    }
  },
  'settings.publish_until_date': {
    presence: {
        allowEmpty: false,
        message: "^Es wurde kein Datum für das Veröffentlichensende angegeben."
    }
  },
  'settings.publish_until_time': {
    presence: {
        allowEmpty: false,
        message: "^Es wurde kein Zeit für das Veröffentlichensende angegeben."
    }
  },
  'settings.lotteries': {
      presence: {
          allowEmpty: false,
          message: "^Es wurde als Ausgabekanal keine Lotterie ausgewählt"
      },
      arrayContainsBooleanTrue: {
          message: "^Es wurde als Ausgabekanal keine Lotterie ausgewählt"
      }
  },
  'settings.platforms': {
      presence: {
          allowEmpty: false,
          message: "^Es wurde als Ausgabekanal kein Zielplattform ausgewählt"
      },
      arrayContainsBooleanTrue: {
          message: "^Es wurde als Ausgabekanal kein Zielplattform ausgewählt"
      }
  },
  'content.0.payload': {
      presence: {
          allowEmpty: false,
          message: "^Es wurde keine Überschrift angegeben"
      },
  },
  'content': {
      containsTextContent: {
          message: '^Der Beitrag enthält keinen Text'
      }
  }
};

const elementConstraints = {
    markdown: {
        payload: {
            presence: {
                allowEmpty: false,
                message: '^Das Element darf nicht leer sein.'
            }
        }
    },
    eventcard: {
        'payload.market': {
            presence: {
                allowEmpty: false,
                message: '^Es wurde kein Markt ausgewählt.'
            }
        },
        'payload.uid': {
            presence: {
                allowEmpty: false,
                message: '^Es wurde kein Event ausgewählt.'
            }
        }
    },
    image: {
        'payload.url': {
            presence: {
                allowEmpty: false,
                message: '^Es wurde kein Bild ausgewählt.'
            }
        }
    }
}

const validation = (state) => produce(state, draft => {
    draft.selected.validation = validate(draft.selected, constraints);

    let hasContentErrors = false;

    for(let key in draft.selected.content){
        let el = draft.selected.content[key];

        if(typeof elementConstraints[el.type] !== 'undefined' && (typeof el.is_deleted === 'undefined' || el.is_deleted === null || el.is_deleted === false)){
            let validationResult = validate(el, elementConstraints[el.type]);
            draft.selected.content[key].validation = (typeof validationResult !== 'undefined')?validationResult:null;
            if(typeof validationResult !== 'undefined' && validationResult !== null && Object.values(validationResult).length > 0)
                hasContentErrors = true;
        }else
            draft.selected.content[key].validation = null;
    }

    if((typeof draft.selected.validation === 'undefined' || draft.selected.validation === null || draft.selected.validation.length === 0) && !hasContentErrors)
        draft.selected.isValid = true;
    else
        draft.selected.isValid = false;
});

export default function stories (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_STORY:
        return request_story(state, action.id)
    case types.RECEIVE_STORY:
        return validation(receive_story(state, action.id, action.data));
    case types.UPDATE_SETTINGS:
        return validation(update_settings(state, action.key, action.value));
    case types.REQUEST_SAVING:
        return request_saving(state, action.id, action.version);
    case types.RECEIVE_SAVING:
        return receive_saving(state, action.id, action.version, action.success);
    case types.UPDATE_CONTENT:
        return validation(update_content(state, action.key, action.value));
    case types.REQUEST_CONTENT_SAVING:
        return request_content_saving(state, action.idx, action.version);
    case types.RECEIVE_CONTENT_SAVING:
        return receive_content_saving(state, action.idx, action.version, action.success);
    case types.REQUEST_STORIES:
        return request_stories(state);
    case types.RECEIVE_STORIES:
        return receive_stories(state, action.stories, action.next);
    case types.REQUEST_PUBLISHING:
        return request_publishing(state);
    case types.RECEIVE_PUBLISHING:
        return receive_publishing(state, action.id, action.version, action.success);
    case types.REQUEST_TRIGGER_PUSH:
        return request_trigger_push(state);
    case types.RECEIVE_TRIGGER_PUSH:
        return receive_trigger_push(state, action.id, action.version, action.success, action.triggeredOn);
    case types.CREATE_DRAFT:
        return validation(create_draft(state, action.id, action.draft_id));
    case types.REQUEST_DELETING:
        return request_deleting(state);
    case types.RECEIVE_DELETING:
        return receive_deleting(state, action.id, action.version, action.success);
    default:
      return state
  }
}
